export function getMicrophoneSupportError(): string | null {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return 'Microphone access is unavailable in this environment.';
  }

  if (!window.isSecureContext) {
    return 'Microphone access requires a secure page. Open Sally via https://... or exactly http://localhost.';
  }

  if (!navigator.mediaDevices) {
    return 'Microphone APIs are unavailable in this browser context. Open Sally via https://... or exactly http://localhost.';
  }

  if (typeof navigator.mediaDevices.getUserMedia !== 'function') {
    return 'This browser does not support microphone capture.';
  }

  if (typeof MediaRecorder === 'undefined') {
    return 'This browser does not support audio recording.';
  }

  return null;
}
